"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.optionsInitialState = void 0;
var defaultTheme = 'base';

try {
  var storedTheme = window.localStorage !== undefined && localStorage.getItem('theme');

  if (typeof storedTheme === 'string') {
    defaultTheme = storedTheme;
  }
} catch (err) {
  console.error(err);
}
/**
 * The initial state of the options area.
 */


var optionsInitialState = {
  themeName: defaultTheme,
  themes: []
};
exports.optionsInitialState = optionsInitialState;